<template lang="pug">
  v-app
    top-bar(:center="$theme.center")
      template(#tabs)
        top-tabs
    blocking-drawer
    v-main
      // top-progress
      blocking-progression
      blocking-menu
      blocking-dialog(:center="$theme.center")
      //v-fade-transition(
        mode="out-in"
        @before-leave="beforeLeave"
        @after-leave="afterLeave")
      router-view(:key="$route.fullPath")
    bottom-snackbar
    bottom-shortcut
    bottom-action
    bottom-navigation
</template>

<script>
import { routes, routeCurrent } from '@iez/core/router/'
import { provide, reactive, watch } from '@vue/composition-api'

import setupTransitions from './setup-transitions/'

import TopBar from '../page/top-bar/component/'
import TopTabs from '../page/top-tabs/component/'
import TopProgress from '../page/top-progress/component/'
import TopBanner from '../page/top-banner/component/'
// import TopHeader from '../page/top-header/component/'

import BlockingDialog from '../page/blocking-dialog/component/'
import BlockingMenu from '../page/blocking-menu/component/'
import BlockingDrawer from '../page/blocking-drawer/component/'
import BlockingProgression from '../page/blocking-progression/component/'

import BottomSnackbar from '../page/bottom-snackbar/component/'
import BottomShortcut from '../page/bottom-shortcut/component/'
import BottomAction from '../page/bottom-action/component/'
import BottomNavigation from '../page/bottom-navigation/component/'

export default {
  components: {
    TopBar,
    TopTabs,
    TopProgress,
    TopBanner,
    // TopHeader,

    BlockingDialog,
    BlockingMenu,
    BlockingDrawer,
    BlockingProgression,

    BottomSnackbar,
    BottomShortcut,
    BottomAction,
    BottomNavigation
  },

  setup () {
    routes.forEach(({ name }) => {
      const states = []
      const getStateByName = ({ name }) =>
        states.find(state => state.name === name)?.value
      watch(
        () => routeCurrent.name,
        () => {
          if (routeCurrent.popState === name) {
            const state = getStateByName({ name })
            if (state) {
              states.splice(
                states.findIndex(_ => _ === state),
                1
              )
            }
          }
        }
      )
      provide(`setup${name}`, (payload, shouldReset) =>
        (() => {
          const state = getStateByName({ name })
          if (state) {
            if (shouldReset && payload) {
              Object.entries(payload)
                .forEach(([key, value]) => {
                  state[key] = value
                })
            }
            return state
          }
        })() ||
        (() => {
          const value = reactive({
            ...payload,
            $name: name
          })
          states.push(({ name, value }))
          return value
        })()
      )
    })

    const { beforeLeave, afterLeave } = setupTransitions()

    return {
      beforeLeave,
      afterLeave
    }
  }
}
</script>

<style>
.no-background.v-text-field--solo > .v-input__control > .v-input__slot {
  background: none !important;
}

.v-list-item--active::before {
  opacity: 0 !important;
}

.v-slider__thumb-container--focused .v-slider__thumb::before {
  transform: scale(0) !important;
}
.v-slider__thumb-container--active .v-slider__thumb::before {
  transform: scale(1) !important;
}
.v-btn:hover::before,
.v-tabs .v-tab--active::before,
.v-card--link:focus:before,
.v-list-item:hover::before {
  opacity: 0 !important;
}
.v-input--selection-controls .v-input--selection-controls__input:hover .v-input--selection-controls__ripple::before {
  background: none !important;
}
.v-sheet {
  border-radius: 8px !important;
}
.v-card {
  border-radius: 16px !important;
}
.v-avatar.rounded-0 {
  border-radius: 8px !important;
}
.no-radius {
  border-radius: 0 !important;
}
.no-radius-top {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.no-radius-bottom {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

/* reset : */
/* - padding for shared element transition */
/* - opacity for shared element transition scroll behavior */
.v-main {
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1), padding 0s, opacity 0s !important;
}

.v-btn {
  text-transform: none !important;
}

.clickable:active {
  transition: 0.2s ease;
  box-shadow: none !important;
}
.notransition {
  transition: none !important;
}
</style>
